/**
 * Shared Tailwind class strings for claim FNOL form controls (`/claims/...`).
 *
 * `<select>` uses `claim-fnol-native-select` in `index.css`: OS arrows often ignore
 * padding and sit flush to the border; that class removes native chrome and draws an
 * inset SVG chevron instead.
 */
const CLAIM_FORM_FIELD_SHELL =
  'w-full rounded-xl border border-solid border-border-primary bg-background-primary font-body text-sm leading-sm text-text-primary-900 shadow-xs placeholder:text-text-placeholder focus:outline-none focus-visible:ring-2 focus-visible:ring-foreground-brand-solid focus-visible:ring-offset-2'

/** Text fields, textareas (combine with layout classes as needed). */
export const CLAIM_FORM_CONTROL_CLASS = `${CLAIM_FORM_FIELD_SHELL} px-[14px] py-[12px]`

/** Native `<select>`: left padding + `claim-fnol-native-select` for inset chevron (see index.css). */
export const CLAIM_FORM_SELECT_CLASS = `${CLAIM_FORM_FIELD_SHELL} py-[12px] pl-[14px] claim-fnol-native-select`
